import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

//
import DoctorCard from "../../../components/doctor-card/DoctorCard";
import DOCTORSLIST from "../../../assets/data/doctor-list";

export default function MeetDoctors() {
  const { t } = useTranslation();

  return (
    <StyledMeetDoctors>
      <div className="container">
        <div className="meet-doctors__wrap">
          <div className="meet-doctors__top">
            <h1 dangerouslySetInnerHTML={{ __html: t("meetDoctorsTitle") }} />
            <p>{t("meetDoctorsText")}</p>
          </div>
          <div className="meet-doctors__bottom">
            <ul className="meet-doctors__list">
              {DOCTORSLIST.slice(0, 3).map((i) => (
                <li key={i.id} className="meet-doctors__list__item">
                  <DoctorCard
                    id={i.id}
                    img={i.img}
                    imagePosition={i.imagePosition}
                    imageScale={i.imageScale}
                    name={i.name}
                    spec={i.specialist}
                    socials={i.socials}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className="meet-doctors__link">
            <Link to="/about/doctor" className="hover-underline">
              {t("meetDoctorsLinkText")} {">>"}
            </Link>
          </div>
        </div>
      </div>
    </StyledMeetDoctors>
  );
}

const StyledMeetDoctors = styled.section`
  background-color: var(--white);
  padding: 140px 0;

  .meet-doctors {
    &__top {
      h1 {
        color: var(--title);
        text-align: center;
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: var(--space-title-subtitle);

        span {
          color: var(--light-blue);
        }
      }

      p {
        width: fit-content;
        max-width: 760px;
        margin: 0 auto var(--space-section-content);
        padding: 10px 24px;
        border-radius: 999px;
        background-color: #f1f6ff;
        color: #173b73;
        text-align: center;
        font-size: var(--fs-subtitle);
        font-style: normal;
        font-weight: var(--fw-medium);
        line-height: var(--lh-subtitle);
      }
    }

    &__list {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 40px;
      margin: 0 0 48px;
    }

    &__link {
      display: flex;
      justify-content: center;

      a {
        color: var(--dark-blue);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 147.059% */

        &::after {
          background-color: var(--dark-blue);
        }
      }
    }
  }
`;
